import React from 'react'
import styled from 'styled-components'
import { Field } from 'redux-form'
import get from 'lodash/get'

import { renderError } from '../../../components/form'

import GuestsInput from '../../../components/form/GuestsInput'
import BookingFormCalendar from '../../../components/enquiry/BookingFormCalendar'
import BookingTimeSlot from '../../../components/enquiry/BookingTimeSlot'

import ConditionalAvailabilityAlert from './AvailabilityAlert/ConditionalAvailabilityAlert'

const Wrapper = styled.div`
  .DateRangePicker,
  .SingleDatePicker {
    width: 100%;
  }
`

const validDate = (value) =>
  !value ? 'Please add dates to request a booking' : undefined
const validEnquiryDate = (value) =>
  !value ? 'Please add your preferred dates to make an enquiry' : undefined

const BookingFormFields = ({
  formName,
  listingId,
  listing,
  enquiry,
  formValues,
  isEnquiryForm,
}) => {
  const enquiryListing = get(enquiry, 'data.listing')

  let startDate
  let endDate

  if (enquiryListing && enquiry && enquiry.data) {
    const { start_date, end_date } = enquiryListing && enquiry && enquiry.data
    startDate = start_date
    endDate = end_date
  }

  return (
    <Wrapper className="fields">
      <div className="field">
        <BookingFormCalendar
          formName={formName}
          listingId={listingId}
          start_date={startDate}
          end_date={endDate}
          snoozed={listing.booking_window === 0}
        />

        <div>
          <Field
            name="booking[start_date]"
            component={renderError}
            validate={[isEnquiryForm ? validEnquiryDate : validDate]}
          />
        </div>

        <Field
          id="booking_start_date"
          name="booking[start_date]"
          component="input"
          type="hidden"
          validate={[isEnquiryForm ? validEnquiryDate : validDate]}
        />

        <Field
          id="booking_end_date"
          name="booking[end_date]"
          component="input"
          type="hidden"
          validate={[isEnquiryForm ? validEnquiryDate : validDate]}
        />
      </div>

      {enquiry && (
        <BookingTimeSlot
          time_slots={enquiry.data && enquiry.data.time_slots}
          formName={formName}
        />
      )}

      <GuestsInput
        capacity={(listing && listing.capacity) || 10}
        guests={
          formValues && formValues.booking.adults + formValues.booking.children
        }
        rounded
      />

      <ConditionalAvailabilityAlert
        endDate={endDate}
        availabilityScore={listing.availability_score}
        style={{ marginTop: '24px' }}
      />
    </Wrapper>
  )
}

export default BookingFormFields
